__turbopack_context__.v({
  "container": "BlogJumbotron-module-scss-module__vL8qoq__container",
  "containerSearch": "BlogJumbotron-module-scss-module__vL8qoq__containerSearch",
  "jumbotron": "BlogJumbotron-module-scss-module__vL8qoq__jumbotron",
  "search": "BlogJumbotron-module-scss-module__vL8qoq__search",
  "wrap": "BlogJumbotron-module-scss-module__vL8qoq__wrap",
});
